import { render, staticRenderFns } from "./EcologicalRecruitment.vue?vue&type=template&id=12d2df28&"
import script from "./EcologicalRecruitment.vue?vue&type=script&lang=js&"
export * from "./EcologicalRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./EcologicalRecruitment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports